app.controller('BrowseOverviewController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const siteHelper = $rootScope.site_helper;

    $scope.newOrder = function ($event) {
        let href = $event && $event.currentTarget ? $event.currentTarget.href : "";
        href = href ? href.replace(/^.*\/\/[^\/]+/, '') : "";
        href = href.replace(/^\/|\/$/g, '');
        const idString = siteHelper.slugToID(href);
        const choiceIDs = idString.split("/");
        if (choiceIDs.length < 2 || choiceIDs[0] !== "browse") {
            return;
        }
        let categoryID = choiceIDs[1];
        if (choiceIDs.length >= 3 && (categoryID === "solution" || categoryID === "component" || categoryID === "site_range")) {
            categoryID += "_" + choiceIDs[2];
        }
        $rootScope.service.cache_browse.removeCategoryCache(categoryID);
    }

    $scope.site_range_cache = $rootScope.model.cache_local_server.site_range.choices;

}]);